
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic06On as ObiHydraulic06OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-06-on.js';
 
 
 

 
 export const ObiHydraulic06On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-06-on',
   elementClass: ObiHydraulic06OnElement,
   events: {
     
   }
  });
 
 